import * as React from 'react';
import useI18n from 'src/hooks/useI18n';

import type {SurveyCardProps} from 'src/types/crm';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  CardActions,
} from '@spaced-out/ui-design-system/lib/components/Card';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {
  ButtonTextMedium,
  SubTitleExtraSmall,
} from '@spaced-out/ui-design-system/lib/components/Text';
import Survey from 'src/components/crm/jobs/job-info/overview/feedbacks/survery/survey';
import {Icon} from '@spaced-out/ui-design-system/lib/components/Icon';

import css from './survey-card.css';


const SurveyCard = ({surveyData, handleRemoveSurvey}: SurveyCardProps) => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  const [isSurveyPanelOpen, setIsSurveyPanelOpen] = React.useState(false);

  return (
    <>
      {isSurveyPanelOpen && (
        <Survey
          isOpen={isSurveyPanelOpen}
          handleClose={() => {
            setIsSurveyPanelOpen(false);
          }}
          handleRemoveSurvey={handleRemoveSurvey}
          surveyId={surveyData.id}
        />
      )}
      <Card
        classNames={{
          wrapper: css.innerCard,
        }}
      >
        <div className={css.cardHeader}>
          <ButtonTextMedium>
            {t('Hiring_Manager_Survey', 'Hiring Manager Survey')}
          </ButtonTextMedium>
          <CardActions>
            <Button
              children={t('Submit_Review', 'Submit Review')}
              onClick={() => {
                setIsSurveyPanelOpen(true);
              }}
              type="tertiary"
              size="small"
              iconLeftName="file-lines"
            />
          </CardActions>
        </div>
        <CardContent className={css.innerCard}>
          <Card
            classNames={{
              wrapper: css.innerApplicationReviewCard,
            }}
            paddingTop="small"
            paddingBottom="small"
          >
            <div className={css.item}>
              <Icon name="briefcase" size="small" />
              <SubTitleExtraSmall>{surveyData.jobTitle}</SubTitleExtraSmall>
            </div>
          </Card>
        </CardContent>
      </Card>
    </>
  );
};

export default SurveyCard;
